/** @format */
import { css } from 'styled-components';

const baseStyles = () => css`
    .xcover-logo {
        display: flex;
        padding-top: var(--layout-spacing-4);
        justify-content: center;
        align-items: center;
        height: var(--layout-spacing-16);
    }
`;

export const styles = () => css`
    ${baseStyles()}
`;
